import React from 'react';
import css from './FragmentItemsTypesSection.module.css';

interface FragmentItemsTypesSectionProps {
    children: React.ReactNode;
}

export const FragmentItemsTypesSection: React.FC<
    FragmentItemsTypesSectionProps
> = ({ children }) => {
    return <div className={css.section}>{children}</div>;
};
